import { render, staticRenderFns } from "./searchInfoVant.vue?vue&type=template&id=5a21409d&scoped=true&"
import script from "./searchInfoVant.vue?vue&type=script&lang=js&"
export * from "./searchInfoVant.vue?vue&type=script&lang=js&"
import style0 from "./searchInfoVant.vue?vue&type=style&index=0&id=5a21409d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a21409d",
  null
  
)

export default component.exports